import React, { Component } from 'react';
import {Link}from 'react-router-dom';

// images

import InfoJumb1 from './images/infoJumbo1.jpg';
import InfoJumb2 from './images/infoJumbo2.jpg';
import InfoJumb3 from './images/infoJumbo3.jpg';

import banner1 from './images/banner1.jpg';

import {Grid, Row, Col, Carousel, Breadcrumb, Button} from 'react-bootstrap';

class Steidle extends Component {
  render() {
    return (
      <div className='container-fluid'>
        <div className="supMainLS">
          <div className="BC">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Lieferanten</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/Suppliers/Zubehoer">Zubehör</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Steidle</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <img src={banner1} alt="Steidle Headquater"/>
        </div>
        <div className="supMainTextLS">
          <h1>Steidle</h1>
          <Grid className="supMainInfo">
          <Row>
            <Col xsHidden smHidden md={5}>
              <Carousel  controls={false} interval={3000}>
                <Carousel.Item >
                    <img  src={InfoJumb1}  alt="Steidle MMKS"  height="100%" />
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb2} alt="Steidle PIC"  height="100%"/>
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb3} alt="Steidle Lager"  height="100%" />
                </Carousel.Item>
              </Carousel>
              </Col>
            <Col xsHidden md={7}>
              <h4>Die Steidle GmbH ist Pionier und Wegbereiter der Technik, die sich heute unter der Bezeichnung Minimalmengen-Kühlschmierung (MMKS) als zukunftsweisende Strategie für die Metallbearbeitung etabliert hat. Gegründet 1979 begann die Steidle GmbH zu Anfang der 80er, als man noch von „Sprühkühlgeräten“ sprach, mit der Produktion eines Niederdruckgerätes. Angespornt vom Erfolg konzentrierte sich die Steidle GmbH auf das Auftragen minimaler Mengen von Flüssigkeiten. Durch die eigene Forschung, Entwicklung und Produktion konnte die Produktpalette stark erweitert werden. So bietet Steidle heute die einzigartige Auswahl von über einem halben Dutzend MMKS-Systemen, für innere und äußere Zuführung, spanabhebende und spanlose Bearbeitungen, Erstausrüster und Endanwender. Sie können sich Ihre individuelle Lösung dabei aus über 900 Komponenten (alleine im Standardbereich) zusammenstellen. Hinzu kommt die Stärke im Bereich der maßgeschneiderten Sonderlösungen, sollte mal doch nicht das Passende zu finden sein.</h4>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden>
              <h4>Die Steidle GmbH ist Pionier und Wegbereiter der Technik, die sich heute unter der Bezeichnung Minimalmengen-Kühlschmierung (MMKS) als zukunftsweisende Strategie für die Metallbearbeitung etabliert hat. Gegründet 1979 begann die Steidle GmbH zu Anfang der 80er, als man noch von „Sprühkühlgeräten“ sprach, mit der Produktion eines Niederdruckgerätes.
            </h4>
            </Col>
            <Col xs={12} md={{ span: 7, offset: 2 }}>
              <Button className="supMainButtonWebPage" variant="light" href="https://www.steidle-gmbh.de/" target="_blank">Hersteller Homepage</Button>
            </Col>
          </Row>
        </Grid>
      </div>
        <br/>
        <section>
        <div className="supMainKeyWords">
          <br/>
          <Grid className="shortDesc">
            <Row>
              <Col xsHidden  sm={4} md={2}>
                <h5>40 Jahre Know-How</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>
                <h5>Pionier und Wegbereiter</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>
                <h5>Made in Germany</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>
                <h5>Standard sowie Sonderlösungen</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>
                <h5>Für Erstausrüster und Endanwender</h5>
              </Col>

            </Row>
            <br/>
            <Row className="show-grid">
              <Col xs={12}  smHidden mdHidden lgHidden>

                <h4>&#9658; &nbsp; Pionier und Wegbereiter</h4>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                  <h4>&#9658; &nbsp; 40 Jahre Know-How</h4>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h4>&#9658; &nbsp; Made in Germany</h4>
              </Col>


            </Row>
          </Grid>
          <br/>
        </div>
        </section>
        <section>

        <Grid className="gridUp">
          <center>
          <h1>Produkte</h1>
          </center>
          <Row className="show-grid">
            <Col  xs={6} sm={6}>
              <center>
              <Link to="/Suppliers/Steidle/MMKS"><h4 className="buttonBlue">MMKS</h4></Link>
            </center>
            </Col>
            <Col  xs={6} sm={6}>
              <center>
              <Link to="/Suppliers/Steidle/PIC"><h4 className="buttonBlue" >PIC</h4></Link>
            </center>
            </Col>

          </Row>

        </Grid>
        <br/>
      </section>
        </div>
    );
  }
}

export default Steidle;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/steidle/mainPageSup.js